export const Icons = {
	IMAGE_EXTENSTION: ".svg",
	HOME_LOGO: "mv_new_pwa_logo_v2",
	LOGIN_BANNER: "login-banner",
	LIST_LOCK_OPEN: "lock-open",
	LIST_LOCK: "lock",
	IC_USER: "ic-user",
	CLOSE_IMAGE: "ic-close",
	ICON_REVIEW_APPROVE: "icon-review-approve",
	ICON_REVIEW_REJECT: "icon-review-reject",
	IC_BACK_ARROW: "ic-back-arrow",
	IC_REJECT_INFO: "ic-reject-info",
	IC_LOG_OUT: "logout",
	IC_ERROR: "ic-error",
	IC_REFRESH: "ic-refresh",
	IC_PAGE_NOT_FOUND: "ic-page-not-found",
	IC_NO_RESULTS_FOUND: "ic-no-results-found",
	IC_MERCHANT_PORTAL_HOME_BANNER: "ic-merchant-portal-home-banner",
};

export const InputType = {
	RADIO: "radio",
	RADIO_LABEL: "radioLabel",
	INPUT: "input",
	BUTTON: "button",
	DATE: "date",
	DATE_TIME: "date_time",
	CHECKBOX: "checkbox",
	CHECKBOX_V2: "checkboxV2",
	LINK: "link",
	SEARCH: "search",
	SELECT: "select",
	AUTOCOMPLETE: "autoComplete",
	BUTTON_CHECKBOX_GROUP: "buttonCheckboxGroup",
	BUTTON_RADIO_GROUP: "buttonRadioGroup",
	BUTTON_RADIO_DATE_GROUP: "buttonRadioDateGroup",
	RANGE_SLIDER: "rangeSlider",
	ACCORDION_GROUP: "accordionGroup",
	ACCORDION_CHECKBOX_GROUP: "accordionCheckboxGroup",
	INPUT_TYPE_GROUP: "inputGroup",
};

export const SNACKBAR_TYPE = {
	ERROR: "error" as "error",
	SUCCESS: "success" as "success",
};

export const dateFormat = {
	formatClient: "DD/MM/YYYY",
	formatClientV2: "DD_MM_YYYY_hh_mm_A",
	formatServer: "DD-MM-YYYY",
	formatDateTimeServer: "yyyy-MM-dd HH:mm:ss", // 2024-09-18 16:49:10
	formatClientDateTime: "dd/MM/yyyy hh:mm aa", // 18/09/2024 04:49 PM
	formatClientV3: {
		day: "2-digit",
		month: "2-digit",
		year: "numeric",
	},
};

export const authProps = {
	MAJOR_VERSION: "majorVersion",
	SECURITY_TOKEN: "token",
	USER_DATA: "new_portal_user_data",
	USER_KEY: "User-Id",
	NO_HEADER: "noHeader",
};
